<template>
  <v-fab-transition>
    <v-tooltip
      left
    >
      <template v-slot:activator="{ on }">
        <v-btn
          :to="link.route"
          color="accent"
          fixed
          right
          bottom
          fab
          large
          :disabled="hideForFreePlan || disabled"
          v-on="on"
        >
          <v-icon>mdi-plus</v-icon>
          <v-chip v-if="hideForFreePlan" class="rounded-lg pro-chip-fab-button px-2" x-small color="accent" text-color="white">PRO</v-chip>
        </v-btn>
      </template>
      <span v-if="link.title != ''">{{link.title}}</span>
    </v-tooltip>
  </v-fab-transition>
</template>

<script>
export default {
    props: {
        link: {
          type: Object,
          default: () => {}
        },
        hideForFreePlan: {
          type: Boolean,
          default: false
        },
        disabled: {
          type: Boolean,
          default: false
        }
    }
}
</script>